<h2 mat-dialog-title>Detalles del error</h2>
<mat-dialog-content>
  <!-- Alerta especial para errores de red (status 0) -->
  <div
    *ngIf="data.errorDetails?.httpStatus === 0"
    style="
      background: #e3f2fd;
      border-left: 4px solid #2196f3;
      padding: 12px 16px;
      margin-bottom: 16px;
      border-radius: 4px;
    "
  >
    <div style="font-weight: 600; color: #0d47a1; margin-bottom: 8px; display: flex; align-items: center">
      <mat-icon style="margin-right: 8px">wifi_off</mat-icon>
      Problema de Conexión
    </div>
    <div style="font-size: 14px; color: #424242; line-height: 1.6">
      No se pudo establecer conexión con el servidor. Esto puede ocurrir por:
      <ul style="margin: 8px 0; padding-left: 20px">
        <li>El servidor está apagado o no disponible</li>
        <li>Problemas de red o firewall</li>
        <li>Error de CORS (Cross-Origin Resource Sharing)</li>
        <li>La URL del servidor no es accesible desde tu ubicación</li>
      </ul>
    </div>
    <div
      *ngIf="data.errorDetails.requestUrl"
      style="
        font-size: 13px;
        color: #757575;
        margin-top: 8px;
        word-break: break-all;
        background: white;
        padding: 8px;
        border-radius: 4px;
      "
    >
      <strong>Servidor intentado:</strong>
      {{ data.errorDetails.requestUrl }}
    </div>
  </div>

  <!-- Mostrar HTTP Status si existe (y no es 0) -->
  <div
    *ngIf="data.errorDetails?.httpStatus && data.errorDetails?.httpStatus !== 0"
    style="
      background: #fff3e0;
      border-left: 4px solid #ff9800;
      padding: 12px 16px;
      margin-bottom: 16px;
      border-radius: 4px;
    "
  >
    <div style="font-weight: 600; color: #e65100; margin-bottom: 4px">HTTP Status</div>
    <div style="font-size: 14px; color: #424242">
      <strong>{{ data.errorDetails.httpStatus }}</strong>
      <span *ngIf="data.errorDetails.httpStatusText">- {{ data.errorDetails.httpStatusText }}</span>
    </div>
    <div
      *ngIf="data.errorDetails.requestUrl"
      style="font-size: 13px; color: #757575; margin-top: 8px; word-break: break-all"
    >
      <strong>Request URL:</strong>
      {{ data.errorDetails.requestUrl }}
    </div>
    <div
      *ngIf="data.errorDetails.httpMethod || data.errorDetails.relativePath"
      style="font-size: 13px; color: #757575; margin-top: 8px"
    >
      <div *ngIf="data.errorDetails.httpMethod" style="margin-bottom: 4px">
        <strong>Method:</strong>
        <code
          style="
            background: #f5f5f5;
            padding: 2px 6px;
            border-radius: 3px;
            font-family: 'Consolas', monospace;
            color: #d32f2f;
          "
        >
          {{ data.errorDetails.httpMethod }}
        </code>
      </div>
      <div *ngIf="data.errorDetails.relativePath" style="word-break: break-all">
        <strong>Endpoint:</strong>
        <code
          style="
            background: #f5f5f5;
            padding: 2px 6px;
            border-radius: 3px;
            font-family: 'Consolas', monospace;
            color: #1976d2;
          "
        >
          {{ data.errorDetails.relativePath }}
        </code>
      </div>
    </div>
  </div>

  <!-- Mensaje de error principal -->
  <div
    *ngIf="data.errorDetails?.message"
    style="
      background: #ffebee;
      border-left: 4px solid #f44336;
      padding: 12px 16px;
      margin-bottom: 16px;
      border-radius: 4px;
    "
  >
    <div style="font-weight: 600; color: #c62828; margin-bottom: 4px">Error Message</div>
    <div style="font-size: 14px; color: #424242; word-break: break-word">{{ data.errorDetails.message?.trim() }}</div>
  </div>

  <!-- Sugerencias de troubleshooting -->
  <div
    *ngIf="data.errorDetails?.troubleshooting && data.errorDetails?.troubleshooting.length > 0"
    style="
      background: #e3f2fd;
      border-left: 4px solid #2196f3;
      padding: 12px 16px;
      margin-bottom: 16px;
      border-radius: 4px;
    "
  >
    <div style="font-weight: 600; color: #1565c0; margin-bottom: 8px; display: flex; align-items: center">
      <mat-icon style="margin-right: 8px; font-size: 20px; width: 20px; height: 20px">lightbulb</mat-icon>
      Sugerencias para mejorar tu consulta
    </div>
    <ul style="margin: 0; padding-left: 20px; color: #424242; font-size: 14px; line-height: 1.6">
      <li *ngFor="let tip of data.errorDetails.troubleshooting" style="margin-bottom: 4px">{{ tip }}</li>
    </ul>
  </div>

  <!-- SQL Query que falló -->
  <div
    *ngIf="data.errorDetails?.sqlQuery"
    style="
      background: #f3e5f5;
      border-left: 4px solid #9c27b0;
      padding: 12px 16px;
      margin-bottom: 16px;
      border-radius: 4px;
    "
  >
    <div style="font-weight: 600; color: #6a1b9a; margin-bottom: 8px">SQL Query</div>
    <pre
      style="
        background: #ffffff;
        padding: 16px;
        border-radius: 4px;
        font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
        font-size: 13px;
        line-height: 1.6;
        max-height: 300px;
        overflow: auto;
        margin: 0;
        color: #333;
        white-space: pre;
        border: 1px solid #e0e0e0;
      "
    >
{{ formattedSqlQuery }}</pre
    >
  </div>

  <!-- AI Prompt que generó el query -->
  <div
    *ngIf="data.errorDetails?.aiPrompt"
    style="
      background: #e8f5e9;
      border-left: 4px solid #4caf50;
      padding: 12px 16px;
      margin-bottom: 16px;
      border-radius: 4px;
    "
  >
    <div style="font-weight: 600; color: #2e7d32; margin-bottom: 8px">AI Prompt</div>
    <div
      style="
        background: #ffffff;
        padding: 12px;
        border-radius: 4px;
        font-size: 13px;
        line-height: 1.5;
        max-height: 150px;
        overflow: auto;
        color: #424242;
        white-space: pre-wrap;
        word-break: break-word;
      "
    >
      {{ data.errorDetails.aiPrompt }}
    </div>
  </div>

  <!-- Detalles completos (JSON) -->
  <details style="margin-top: 16px">
    <summary style="cursor: pointer; font-weight: 600; color: #1976d2; user-select: none">
      Ver detalles técnicos completos
    </summary>
    <pre
      style="
        white-space: pre-wrap;
        word-break: break-all;
        background: #f8f8f8;
        padding: 16px;
        border-radius: 6px;
        max-height: 400px;
        overflow: auto;
        margin-top: 12px;
        font-size: 13px;
      "
    >
{{ data.errorDetails | json }}</pre
    >
  </details>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cerrar</button>
</mat-dialog-actions>
